(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/terminate-team-popover-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/terminate-team-popover-item.js');
'use strict';

const {
  useHistory
} = ReactRouterDOM;
const {
  showTechnicalError,
  showDeleteTeamSuccess,
  showDeleteTeamQuestionDialog,
  showDeleteTeamSuccessAlt
} = svs.arena.pages.teams.dialogs;
const {
  TEAMS
} = svs.arena.constants.routes;
const {
  removeTeam
} = svs.arena.store.teams.actions;
const {
  putTerminateSyndicateAsync
} = svs.arena.service.teamsService;
const {
  MemberPopoverItem
} = svs.arena.pages.teams.components;
const TerminateTeamPopoverItem = _ref => {
  let {
    teamName,
    teamId,
    amount
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  const handleClick = async () => {
    if (!(await showDeleteTeamQuestionDialog(teamName))) {
      const track = {
        category: 'spela-tillsammans',
        action: 'finish_team',
        opt_label: 'cancel'
      };
      svs.components.analytics.trackEvent(track);
      return;
    }
    const {
      error
    } = await putTerminateSyndicateAsync(teamId);
    if (error) {
      showTechnicalError();
      return;
    }
    const track = {
      category: 'spela-tillsammans',
      action: 'finish_team',
      opt_label: 'delete'
    };
    svs.components.analytics.trackEvent(track);
    if (parseInt(amount, 10) > 0) {
      showDeleteTeamSuccessAlt(teamName, amount);
    } else {
      showDeleteTeamSuccess(teamName);
    }
    history.push(TEAMS);
    dispatch(removeTeam(teamId));
  };
  return React.createElement(MemberPopoverItem, {
    onClick: handleClick
  }, "Avsluta laget");
};
svs.arena.pages.teams.components.TerminateTeamPopoverItem = TerminateTeamPopoverItem;

 })(window);